<template>
  <v-main>
    <BlockUI v-if="getIsVesselMonitoringLoading" :message="loadingMessage">
      <i class="fa fa-spinner fa-spin fa-2x fa-fw"></i>
    </BlockUI>
    <div
      v-if="!getVesselMonitoringResponse.isSuccessful"
      style="font-size: large; justify-self: center;"
      class="mt-2 ml-2"
    >
      {{getVesselMonitoringResponse.message[0].messageText}}
    </div>
    <div v-else>
      <BlockUI v-if="!getFinishRendering" :message="loadingMessage">
        <i class="fa fa-spinner fa-spin fa-2x fa-fw"></i>
      </BlockUI>
      <div class="p-2">
        <div v-if="getFinishRendering">
          <v-row v-show="!fullscreenMode" style="padding: 10px;">
            <container-details-modal></container-details-modal>
            <handling-quay-equipment-detail-modal></handling-quay-equipment-detail-modal>
            <v-col cols="12" sm="6" md="4" lg="3">
              <v-select
                hide-details="auto"
                dense
                outlined
                item-text="display"
                v-model="selectedView"
                :items="viewOptionsItems"
                label="View"
              ></v-select>
            </v-col>
            <!-- Select bay -->
            <v-col cols="12" sm="6" md="4" lg="3">
              <v-row
                align="center"
                no-gutters
                class="select-row"
                style="flex-wrap: nowrap;"
              >
                <v-btn
                  icon
                  small
                  class="arrow-button"
                  :disabled="isBaySelectDisabled"
                  @click="selectPreviousItem"
                >
                  <v-icon size="24" style="color: white;"
                    >mdi-chevron-left</v-icon
                  >
                </v-btn>

                <v-select
                  hide-details="auto"
                  dense
                  outlined
                  item-text="display"
                  v-model="selectedBay"
                  :items="bayOptionsItems"
                  label="Bay"
                  :disabled="isBaySelectDisabled"
                  class="select-box"
                ></v-select>

                <v-btn
                  icon
                  small
                  class="arrow-button"
                  :disabled="isBaySelectDisabled"
                  @click="selectNextItem"
                >
                  <v-icon size="24" style="color: white;"
                    >mdi-chevron-right</v-icon
                  >
                </v-btn>
              </v-row>
            </v-col>

            <v-col cols="12" sm="6" md="4" lg="3">
              <v-select
                hide-details="auto"
                dense
                outlined
                item-text="display"
                v-model="selectedDeck"
                :items="deckOptionsItems"
                label="Deck"
                :disabled="this.isDeckSelectDisabled"
              ></v-select>
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="3">
              <button
                type="button"
                @click="Print_Click"
                class="btn btn-outline-primary font-weight-bold btn-sm mr-2 Mybtn1-primary Mybtn-size1"
              >
                <i class="fas fa-print"></i>
                <span class="hideButtonTitle">Print</span>
              </button>
            </v-col>
          </v-row>

          <v-row style="display: flex; justify-content: center;">
            <v-col cols="12" sm="6" md="4" lg="3">
              <v-select
                hide-details="auto"
                dense
                outlined
                item-text="display"
                v-model="selectedColorBy"
                :items="colorByOptionsItems"
                label="Color By"
              ></v-select>
            </v-col>
           <v-col v-if="selectedView !== 1 && ShowWeightLevelCheckBox" cols="12" sm="6" md="4" lg="3">
              <v-checkbox v-model="ShowWeightLevel"  label="Show Weight Level" hide-details></v-checkbox>
            </v-col>
          </v-row>

          <v-row
            data-name="color-palettes"
            class="d-flex flex-nowrap flex-row justify-content-center align-items-center mb-3 lighten-4"
          >
            <v-col class="d-flex justify-content-center" cols="12">
              <div
                v-for="(value, index) in colorPalettes"
                class="d-flex  container-type-legend"
              >
                <div class="px-2">
                  <ContainerTypeBadge :data="value" />
                </div>
              </div>
            </v-col>
          </v-row>
        </div>
        <v-row>
          <v-col v-if="selectedView === 1 /* VesselMonitoringView.SingleBay */">
            <single-bay-view></single-bay-view>
          </v-col>
          <v-col
            v-else-if="
              selectedView === 2 /* VesselMonitoringView.MiniOneBayWide */
            "
          >
            <one-bay-wide></one-bay-wide>
          </v-col>
          <v-col v-else-if="selectedView === 3 /* VesselMonitoringView.mini */">
            <all-bays></all-bays>
          </v-col>
        </v-row>
      </div>
    </div>
  </v-main>
</template>

<script>
import ContainerTypeBadge from "@/view/pages/vesselMonitoring/components/ContainerTypeBadge.vue";
import AllBays from "@/view/pages/vesselMonitoring/components/AllBaysView/AllBays.vue";
import OneBayWide from "@/view/pages/vesselMonitoring/components/OneBayWideView/OneBayWide.vue";
import ContainerDetailsModal from "@/view/pages/vesselMonitoring/components/ContainerDetailsModal";
import HandlingQuayEquipmentDetailModal from "@/view/pages/vesselMonitoring/components/HandlingQuayEquipmentDetailModal.vue";

import SingleBayView from "@/view/pages/vesselMonitoring/components/SingleBayView/SingleBayView.vue";
import { mapGetters, mapActions } from "vuex";
import {
  VesselMonitoringView,
  VesselBay,
  VesselMonitoringDeck,
} from "@/core/services/store/vesselMonitoring.types";

export default {
  components: {
    ContainerTypeBadge,
    AllBays,
    SingleBayView,
    OneBayWide,
    ContainerDetailsModal,
    HandlingQuayEquipmentDetailModal
  },
  data() {
    return {
      showWeightLevel:false,
      fullscreenMode:false,
      singleBayViewKey: "o",
      // selectedView: getSelectedView,
      // TODO: get from enum
      viewOptions: [
        {
          display: "Single Bay",
          value: VesselMonitoringView.SingleBay,
        },
        {
          display: "Mini - One bay wide",
          value: VesselMonitoringView.MiniOneBayWide,
        },
        {
          display: "Mini - All bays",
          value: VesselMonitoringView.MiniAllBays,
        },
      ],
      deckOptions: [
        {
          display: "Above",
          value: VesselMonitoringDeck.Above,
        },
        {
          display: "Below",
          value: VesselMonitoringDeck.Below,
        },
        {
          display: "Both",
          value: VesselMonitoringDeck.Both,
        },
      ],
    };
  },
  methods: {
    reload() {
      window.reload();
      // Get the ID from the route
      const vesselId = this.$route.params.id;

      // Update the Vuex store
      this.$store.commit("setVesselIdMutation", Number(vesselId));

      // update request data
      this.setPropertiesFromQueryString({
        operationStatus: Number(this.$route.query.operationStatus),
        operationType: Number(this.$route.query.operationType),
      });

      // page api request
      this.fetchVesselMonitoringColorByList();
      this.fetchVesselMonitoringBayList();
      this.fetchVesselMonitoring2DBayView();
      this.fetchGantryCrane();
    },
    selectNextItem() {
      let currentIndex = this.bayOptionsItems.findIndex(
        (item) => item.value === this.selectedBay
      );
      if (currentIndex >= 0 && currentIndex < this.bayOptionsItems.length - 1) {
        this.selectedBay = this.bayOptionsItems[currentIndex + 1].value;
      } else {
        this.selectedBay = this.bayOptionsItems[0].value; // Wrap around to the first item
      }
    },
    selectPreviousItem() {
      let currentIndex = this.bayOptionsItems.findIndex(
        (item) => item.value === this.selectedBay
      );
      if (currentIndex > 0) {
        this.selectedBay = this.bayOptionsItems[currentIndex - 1].value;
      } else {
        this.selectedBay = this.bayOptionsItems[
          this.bayOptionsItems.length - 1
        ].value; // Wrap around to the last item
      }
    },
    ...mapActions([
      "fetchVesselMonitoring2DBayView",
      "setPropertiesFromQueryString",
      "fetchVesselMonitoringColorByList",
      "fetchVesselMonitoringBayList",
      "setSelectedDeck",
      "setSelectedBay",
      "setSelectedView",
      "setSelectedColorBy",
      "setShowWeightLevel",
      "setShowWeightLevelChekbox",
      "print",
      "fetchGantryCrane"
    ]),
    Print_Click() {
      this.print();
    },
     async tryEnterFullScreenOnLoad(data) {
       var data = JSON.parse(event.data);
        if (data && data.action == "enterFullScreen") {
          this.fullscreenMode = true;
        }
        else if (data && data.action == "exitFullScreen") {
          this.fullscreenMode = false;
        }
    }
  },
  computed: {
    ...mapGetters([
      "getIsVesselMonitoringContainerDetailModalOpen",
      "getVesselMonitoringResponse",
      "getVesselMonitoringContainerDetailResponse",
      "getColorByList",
      "getIsVesselMonitoringLoading",
      "setIsVesselMonitoringLoading",
      "getColorPalettes",
      "getSelectedDeck",
      "getSelectedBay",
      "getSelectedView",
      "getSelectedColorBy",
      "getShowWeightLevel",
      "getShowWeightLevelChekbox",
      "getBayList",
      "getColorByList",
      "getLoadingMessage",
      "setLoadingMessage",
      "getFinishRendering",
      "getGenerateplot"
    ]),
    IsVesselMonitoringContainerDetailModalOpen: {
      get() {
        return this.getIsVesselMonitoringContainerDetailModalOpen;
      } /* ,
      set(value) {
        this.setIsVesselMonitoringContainerDetailModalOpen(value)
      } */,
    },

    isLoading: {
      get() {
        return this.getIsVesselMonitoringLoading;
      },
      set(value) {
        this.setIsVesselMonitoringLoading(value);
      },
    },
    selectedView: {
      get() {
        // return selected view, if not selected
        return this.getSelectedView || 3;
      },
      set(value) {
        this.setSelectedView(value);
      },
    },
    loadingMessage: {
      get() {
        return this.getLoadingMessage;
      },
      set(value) {
        this.setLoadingMessage;
      },
    },
    selectedColorBy: {
      get() {
        return this.getSelectedColorBy;
      },
      set(value) {
        this.setSelectedColorBy(value);
      },
    },
    ShowWeightLevel: {
      get() {
        return this.getShowWeightLevel;
      },
      set(value) {
        this.setShowWeightLevel(value);
      },
    },
    ShowWeightLevelCheckBox: {
      get() {
        return this.getShowWeightLevelChekbox;
      },
      set(value) {
        this.setShowWeightLevelChekbox(value);
      },
    },
    colorPalettes() {
      return this.getColorPalettes;
    },
    bayOptions() {
      return this.getBayList;
    },
    colorByOptions() {
      return this.getColorByList;
    },
    selectedBay: {
      get() {
        return this.getSelectedBay;
      },
      set(value) {
        this.setSelectedBay(value);
      },
    },
    selectedDeck: {
      get() {
        return this.getSelectedDeck;
      },
      set(value) {
        this.setSelectedDeck(value);
      },
    },
    isSingleBay() {
      return this.selectedView === "Single Bay";
    },
    viewOptionsItems() {
      return this.viewOptions.map((e) => {
        return {
          display: e.display,
          value: e.value,
        };
      });
    },
    deckOptionsItems() {
      return this.deckOptions.map((e) => {
        return {
          display: e.display,
          value: e.value,
        };
      });
    },
    bayOptionsItems() {
      return this.bayOptions.map((e) => {
        return {
          display: e.bayNo,
          value: e.bay,
        };
      });
    },
    colorByOptionsItems() {
      return this.colorByOptions.map((e) => {
        return {
          display: e.name,
          value: e.id,
        };
      });
    },
    isOneBayWide() {
      return this.selectedView === "Mini - One bay wide";
    },
    isAllBays() {
      return this.selectedview === "mini - all bays";
    },
    isDeckSelectDisabled() {
      return !(this.selectedView === VesselMonitoringView.SingleBay);
    },
    isBaySelectDisabled() {
      return !(this.selectedView === VesselMonitoringView.SingleBay);
    },
  },
  mounted() {
    window.addEventListener("message", this.tryEnterFullScreenOnLoad);
  },
    beforeDestroy() {
    window.removeEventListener("message", this.tryEnterFullScreenOnLoad);
  },
  created() {
    // Get the ID from the route
    const vesselId = this.$route.params.id;

    // Update the Vuex store
    this.$store.commit("setVesselIdMutation", Number(vesselId));

    // update request data
    this.setPropertiesFromQueryString({
      operationStatus: Number(this.$route.query.operationStatus),
      operationType: Number(this.$route.query.operationType),
    });

    // page api request
    this.fetchVesselMonitoringColorByList();
    this.fetchVesselMonitoringBayList();
    this.fetchVesselMonitoring2DBayView();
    this.fetchGantryCrane();
  },
  watch: {
    getGenerateplot: function(item) {
      try {
        const blob = this.getGenerateplot;
        const url = URL.createObjectURL(blob);
        window.open(url, "_blank"); // باز کردن PDF در تب جدید
      } catch (error) {
        console.error("خطا در دریافت و باز کردن PDF:", error);
      }
    },
  },
};
</script>

<style scoped>
.container-type-legend {
  display: flex;
  gap: 1rem;
  justify-content: center;
  align-items: center;
}

.container-type-legend v-badge {
  margin-right: 10px;
}

.container-icons {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 2rem;
  flex-wrap: wrap;
}

.container-icons v-icon {
  font-size: 18px;
  margin-right: 10px;
}

.container-type-legend v-badge[color="red"]::before {
  background-color: red;
}

.container-type-legend v-badge[color="grey"]::before {
  background-color: grey;
}

.container-type-legend v-badge[color="blue"]::before {
  background-color: blue;
}

.select-row {
  background-color: #009999;
  border-radius: 4px;
}

.arrow-button {
  color: white;
  fill: white;
  background-color: transparent;
  border: none;
}

.select-box {
  flex-grow: 1;
  margin: 0 8px;
  background-color: transparent;
  color: white;
  background-color: #fff;
  border-color: #009999;
}

.v-select__selections {
  color: white;
}
@media (min-width: 1264px) {
    .container {
        max-width: 1326px;
    }
}
</style>
